var _path, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    id: "angular",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M21.317,18.755L23,3.986L12,0L1,3.986l1.684,14.769L12,24L21.317,18.755L21.317,18.755z M7.692,18.311H5.114L12,2.651l6.892,15.66h-2.573l-1.387-3.504H9.079L7.692,18.311L7.692,18.311z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F44336",
    points: "9.983 12.648 14.017 12.648 12 7.741 9.983 12.648"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DEDEDE",
    points: "12 2.651 5.114 18.311 7.692 18.311 9.079 14.807 12 14.807 12 12.648 9.983 12.648 12 7.741 12 2.651"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D43A2F",
    points: "12 0 1 3.986 2.684 18.755 12 24 12 14.807 9.079 14.807 7.692 18.311 5.114 18.311 12 2.651 12 0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D43A2F",
    points: "12 7.741 9.983 12.648 12 12.648 12 7.741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.b4ef8bbfc367c5e4951d0b76dceb4dba.svg";
export { ForwardRef as ReactComponent };